import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Grid3X3, Layers, Square, Shield } from 'lucide-react';

const iconMap = {
  grid: Grid3X3,
  layers: Layers,
  square: Square,
  shield: Shield,
};

export const ArticleProductRecommendations = ({ recommendations, introText }) => {
  if (!recommendations || recommendations.length === 0) return null;

  return (
    <section className="bg-stone-50 border-t border-stone-200 py-14 md:py-20" data-testid="article-product-recommendations">
      <div className="container-portico">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-2">Recommended Solutions</p>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-stone-900 mb-3">
            Explore Product Options
          </h2>
          {introText && (
            <p className="text-stone-500 max-w-xl mx-auto text-sm md:text-base">
              {introText}
            </p>
          )}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-5xl mx-auto">
          {recommendations.map((rec, i) => {
            const Icon = iconMap[rec.icon] || Square;
            return (
              <motion.div
                key={rec.link || rec.title || `rec-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.35 }}
              >
                <Link
                  to={rec.link}
                  className="group block bg-white rounded-xl border border-stone-200 p-6 shadow-sm hover:shadow-md hover:border-primary/30 transition-all h-full"
                  data-testid={`product-rec-${i}`}
                >
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                    <Icon className="w-5 h-5 text-primary" />
                  </div>
                  <h3 className="font-heading font-semibold text-stone-900 mb-2 group-hover:text-primary transition-colors">
                    {rec.title}
                  </h3>
                  <p className="text-sm text-stone-500 leading-relaxed mb-4">
                    {rec.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
                    View Products <ArrowRight className="w-3.5 h-3.5" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
